(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eb-announcement')) {
  customElements.define('eb-announcement', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.eb-announcement__item')];
      this.index = 0;


      this.focused = false;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('focusin', event => { this.focused = true; }, options);
      this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); }); }, options);
      clearInterval(this.timer);
      if (this.items.length > 1) this.timer = setInterval(() => this.advance(), 3000);
    }
    advance() {
      if (this.focused || document.hidden) return;
      const previous = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      const next = this.items[this.index];
      next.classList.remove('is-leaving', 'is-animating', 'is-current');
      void next.offsetHeight;
      previous.classList.add('is-animating');
      next.classList.add('is-animating');
      previous.classList.remove('is-current');
      previous.classList.add('is-leaving');
      previous.inert = true;
      previous.setAttribute('aria-hidden', 'true');
      next.classList.add('is-current');
      next.inert = false;
      next.removeAttribute('aria-hidden');
      clearTimeout(this.cleanup);
      this.cleanup = setTimeout(() => { previous.classList.remove('is-leaving', 'is-animating'); next.classList.remove('is-animating'); }, 500);
    }
    disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.cleanup); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-footer"]) return;
  try {
    
if (!customElements.get('eb-footer-accordions')) {
  customElements.define('eb-footer-accordions', class extends HTMLElement {
    connectedCallback() {
      this.cookieButton = this.querySelector('.eb-footer-cookie-preferences');
      this.cookieStatus = this.querySelector('.eb-footer-cookie-status');
      this.openCookiePreferences = async () => {
        this.cookieStatus.textContent = '';
        this.cookieButton.disabled = true;
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') {
            throw new Error('Cookie banner unavailable');
          }
          await window.privacyBanner.showPreferences();
        } catch {
          this.cookieStatus.textContent = 'Les préférences ne sont pas disponibles pour le moment. Rechargez la page puis réessayez.';
        } finally {
          this.cookieButton.disabled = false;
        }
      };
      this.cookieButton?.addEventListener('click', this.openCookiePreferences);
      this.desktop = matchMedia('(min-width: 990px)');
      this.updateLayout = () => this.querySelectorAll('.eb-footer-group').forEach(group => { group.open = this.desktop.matches; });
      this.updateLayout();
      this.desktop.addEventListener('change', this.updateLayout);
    }
    disconnectedCallback() { this.desktop?.removeEventListener('change', this.updateLayout); this.cookieButton?.removeEventListener('click', this.openCookiePreferences); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-recent-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eb-recent-products')) {
  customElements.define('eb-recent-products', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      const key = 'eb-recent-products-v1';
      const valid = (handle) => typeof handle === 'string' && handle.length > 0 && handle.length < 200 && !/[\s/?#]/u.test(handle);
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(stored)) history = [...new Set(stored.filter(valid))].slice(0, 8);
      } catch {}
      const current = this.dataset.current;
      if (valid(current)) {
        history = [current, ...history.filter(handle => handle !== current)].slice(0, 8);
        try { localStorage.setItem(key, JSON.stringify(history)); } catch {}
      }
      const handles = history.filter(handle => handle !== current);
      const limit = Math.min(8, Math.max(2, Number(this.dataset.limit) || 4));
      const root = new URL(this.dataset.root || '/', location.origin);
      if (root.origin !== location.origin) return;
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      const list = this.querySelector('.eb-recent-grid');
      const results = await Promise.all(handles.map(async handle => {
        try {
          const url = new URL(`products/${encodeURIComponent(handle)}.js`, root);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) return null;
          const item = await response.json();
          if (!valid(item.handle) || typeof item.title !== 'string') return null;
          return item;
        } catch { return null; }
      }));
      if (!this.isConnected) return;
      let formatter;
      try {
        formatter = new Intl.NumberFormat(this.dataset.locale || 'fr', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        });
      } catch { return; }
      for (const item of results.filter(Boolean).slice(0, limit)) {
        const card = document.createElement('a');
        card.className = 'eb-recent-card';
        card.href = new URL(`products/${encodeURIComponent(item.handle)}`, root).href;
        if (typeof item.featured_image === 'string' && item.featured_image) {
          try {
            const imageUrl = new URL(item.featured_image, location.origin);
            if (imageUrl.protocol === 'https:' || imageUrl.origin === location.origin) {
              imageUrl.searchParams.set('width', '600');
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = item.title;
              image.loading = 'lazy';
              image.width = 600;
              image.height = 800;
              card.append(image);
            }
          } catch {}
        }
        const title = document.createElement('h3');
        title.textContent = item.title;
        card.append(title);
        if (Number.isFinite(Number(item.price))) {
          const price = document.createElement('p');
          price.textContent = formatter.format(Number(item.price) / 100);
          card.append(price);
        }
        list.append(card);
      }
      if (list.children.length || this.dataset.editor === 'true') this.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
